import { Button, Typography } from '@mui/material';

import { Placeholder } from 'modules/common/components/Placeholder';
import { ReferralProgram } from 'modules/strapi/types';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { Benefits } from '../Benefits';
import {
  IReferralFlowDialogProps,
  ReferralFlowDialog,
} from '../ReferralFlowDialog';
import { successDialogTranslation } from './translation';
import { useSuccessDialogStyles } from './useSuccessDialogStyles';

export interface ISuccessDialogProps extends IReferralFlowDialogProps {
  onDoneButtonClick: () => void;
  referralProgram: ReferralProgram | undefined;
}

export const SuccessDialog = ({
  onDoneButtonClick,
  referralProgram,
  ...dialogProps
}: ISuccessDialogProps) => {
  const {
    keys: { branded, unbranded },
    t,
    tHTML,
  } = useTranslation(successDialogTranslation);

  const keys = referralProgram ? branded : unbranded;

  const { classes } = useSuccessDialogStyles();

  return (
    <ReferralFlowDialog {...dialogProps}>
      <div className={classes.content}>
        <Typography variant="h6">{t(keys.title)}</Typography>
        <Typography variant="body2">{tHTML(keys.description)}</Typography>
        <Placeholder hasPlaceholder={!referralProgram} placeholder={null}>
          <Benefits referralProgram={referralProgram!} />
        </Placeholder>
      </div>
      <Button
        color="primary"
        onClick={onDoneButtonClick}
        size="large"
        variant="contained"
      >
        {t(keys.doneButton)}
      </Button>
    </ReferralFlowDialog>
  );
};
